"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getSources = require("@studio/sources/getSources");
var _Sources = require("@studio/constants/Sources");
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("../attendee/setMultipleDesiredAttendeeMuteStatuses"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function muteSourcesRemovedFromProgram(source) {
  return function (dispatch, getState) {
    var _getState = getState(),
      layers = _getState.program.layers;
    if (layers.length) {
      var sourcesMuteStatus = layers === null || layers === void 0 ? void 0 : layers.reduce(function (acc, layer) {
        if (layer.source.type === _Sources.CAMERA_PRESENTER && layer.source._id !== (source === null || source === void 0 ? void 0 : source._id)) {
          var sourceValue = (0, _getSources.getSourceValue)(layer.source);
          acc[sourceValue] = true;
        }
        return acc;
      }, {});
      dispatch((0, _setMultipleDesiredAttendeeMuteStatuses["default"])(sourcesMuteStatus));
    }
  };
}
var _default = exports["default"] = muteSourcesRemovedFromProgram;